import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import debounce from "lodash/debounce";
import { register, unregister } from "@shared/core/globalClick";
import SvgIcon from "@components/icon/svg";

const Wrapper = "CityWrapper";

function prepareCities(cities) {
  const { idMap, hotCityList, letterMap } = cities.reduce(
    ({ idMap, hotCityList, letterMap }, city) => {
      // eslint-disable-line
      const firstLetter = city.pynm && city.pynm[0] && city.pynm[0].toUpperCase();
      idMap[city.id] = city; // eslint-disable-line
      letterMap[firstLetter] = letterMap[firstLetter] || []; // eslint-disable-line
      letterMap[firstLetter].push(city);
      if (city.hot) hotCityList.push(city);
      return { idMap, letterMap, hotCityList };
    },
    { idMap: {}, hotCityList: [], letterMap: {} }
  );

  const listByFirstLetter = Object.keys(letterMap).map(letter => ({
    letter,
    ascii: letter.charCodeAt(0),
    list: letterMap[letter],
  }));

  listByFirstLetter.sort((a, b) => (a.ascii < b.ascii ? -1 : 1));

  return { cities, cityMapById: idMap, hotCityList, citiesByLetter: listByFirstLetter };
}

class City extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...prepareCities(props.cities),
      display: false,
      keyword: "",
      filteredCities: [],
    };
    this.onChangeCity = this.onChangeCity.bind(this);
    this.syncFilteredListDebounced = debounce(this.syncFilteredList.bind(this), 100);
  }

  componentDidMount() {
    register(this, Wrapper);
  }

  componentWillUnmount() {
    unregister(this, Wrapper);
  }

  onGlobalClick() {
    if (this.state.display) {
      this.setState({
        display: false,
      });
    }
  }

  onChangeCity({ id: cityId, pynm, nm: cityName }) {
    this.setState({
      display: false,
    });
    this.props.onChange({ cityId, pynm, cityName });
  }

  syncFilteredList() {
    const { cities } = this.state;
    const keyword = this.state.keyword && this.state.keyword.trim();

    this.setState({
      filteredCities: cities.filter(
        item =>
          item.nm.indexOf(keyword) !== -1 || item.pynm.indexOf(keyword) === 0 || item.pyAbbr.indexOf(keyword) === 0
      ),
    });
  }

  renderCityItem(item, curCityId) {
    return (
      <li key={item.id}>
        <a
          href={item.pynm ? `/${item.pynm}/` : "javascript:void(0)"}
          className={cx("btn", {
            "btn-default": item.id !== curCityId,
            "btn-primary": item.id === curCityId,
          })}
          onClick={e => {
            e.preventDefault();
            this.onChangeCity(item);
          }}
        >
          {item.nm}
        </a>
      </li>
    );
  }

  render() {
    const { value, dontRenderDropdown: dtrd } = this.props;
    const { filteredCities, cityMapById, citiesByLetter, keyword, hotCityList, display } = this.state;
    const cityId = +value;
    const city = cityMapById[cityId];

    return (
      <div className="search-menu search-menu__city" ref={Wrapper}>
        <button
          type="button"
          className={cx("search-menu__label search-menu__label--city", {
            "search-menu__label--active": this.state.display,
            "search-menu__label--highlight": city && city.nm,
          })}
          onClick={() => {
            this.setState({
              display: !this.state.display,
              keyword: "",
            });
          }}
        >
          <SvgIcon symbol={require("@shared/icons/locate-home.svg")} />
          {(city && city.nm) || "选择城市"}
          <SvgIcon symbol={require("@shared/icons/expand-thin.svg")} size="xs" />
        </button>
        {!(!dtrd || display) || (
          <div className="search-menu__content" role="menu" style={{ display: display ? "block" : "none" }}>
            <input
              type="text"
              onChange={e => {
                this.setState({ keyword: e.target.value }, this.syncFilteredListDebounced);
              }}
              placeholder="城市名称或拼音"
              value={keyword}
            />
            {keyword ? (
              <div className="filter-cities filter-cities--keyword" data-list-type="搜索结果">
                <ul className="city-grid list-inline">
                  {filteredCities.map(item => this.renderCityItem(item, cityId))}
                </ul>
              </div>
            ) : (
              <Fragment>
                <div className="filter-cities filter-cities--hot" data-list-type="热门城市">
                  <ul className="city-grid list-inline">
                    {hotCityList.map(item => this.renderCityItem(item, cityId))}
                  </ul>
                </div>
                <div className="filter-cities filter-cities--all" data-list-type="全部城市">
                  <h3>全部城市</h3>
                  <ul className="city-letter-grid list-unstyled">
                    {citiesByLetter.map(letterInfo => (
                      <li key={`licity-${letterInfo.letter}`}>
                        <h4>{letterInfo.letter}</h4>
                        <ul className="city-grid list-inline">
                          {letterInfo.list.map(item => this.renderCityItem(item, cityId))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </Fragment>
            )}
          </div>
        )}
      </div>
    );
  }
}

City.propTypes = {
  cities: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  dontRenderDropdown: PropTypes.bool,
};

City.defaultProps = {
  value: undefined,
  dontRenderDropdown: false,
};

export default City;

require("./city.less");
require("./index.less");